import React, { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { formatMoney } from "../../../helpers/formatter";

export interface InvestorTopUpData {
  funder_investment_id: number;
  top_up_amount: number;
  transaction_date: string;
  topup_type: string;
  topup_type_name: string;
  proof_of_payment_path: string;
  wallet_id: string;
  currency_code: string;
  narration: string;
  reference: string;
  user_id: number;
  investment_product_name: string;
  deposit_type: string;
  investment_reference_number: string;
  funder_id: number;
  funder_type: number;
  firstname: string;
  lastname: string;
  email: string;
  phone_number: string;
  biz_name: string;
  biz_email: string;
  funder_document_id: number;
  internal_transaction_reference: string;
}

interface RequestsDataTableProps {
  data: InvestorTopUpData[];
  showModal: any;
  hideModal: any;
  initiator: "investor" | "admin";
}

const TopUpRequestsTopUpDataTable: FunctionComponent<
  RequestsDataTableProps
> = ({ data, showModal, hideModal, initiator }) => {
  return (
    <div className="row m-x-sm m-y-2 grid__padding">
      <div className="table-responsive">
        <table className="table">
          <thead className="bg-lighter-grey">
            <tr>
              <th>S/N</th>
              <th>Investment ID</th>
              <th>Top-Up Amount</th>
              <th>Top-Up Type</th>
              <th>Wallet ID</th>
              <th>Currency</th>
              <th>Phone Number</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={item.funder_investment_id}>
                <td>{index + 1}</td>
                <td>{item.funder_investment_id}</td>
                <td>{formatMoney(item.top_up_amount, item.currency_code)}</td>
                <td>{item.topup_type}</td>
                <td>{item.wallet_id}</td>
                <td>{item.currency_code}</td>
                <td>{item.phone_number}</td>
                <td>
                  <button
                    className="btn advancly-nobg-btn btn-sm transition-3d-hover mt-2 mr-2"
                    type="button"
                    data-toggle="modal"
                    data-target="#requestModal"
                    onClick={() => {
                      showModal({
                        modalIdentifier: "requests",
                        action: "top_up_request",
                        item: { ...item, initiator },
                      });
                    }}
                  >
                    Request
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopUpRequestsTopUpDataTable;
